var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"footer"},[_vm._t("default"),_c('span',{staticStyle:{"display":"inline-bolck","float":"right"}},[_vm._t("right")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }